import React from "react";
import "./SectionLabel.css";

export default function SectionLabel({ as: Tag = "span", tone = "default", children }) {
  const className = `trunfo-section-label trunfo-section-label--${tone}`;
  return <Tag className={className}>{children}</Tag>;
}
